var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramActionSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 5,
    fill: "#272A3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 7C16.1281 7 16.3333 7.20987 16.3333 7.46875C16.3333 7.72763 16.5385 7.9375 16.7917 7.9375C17.0448 7.9375 17.25 8.14737 17.25 8.40625V8.875C17.25 9.13388 17.0448 9.34375 16.7917 9.34375H12.2083C11.9552 9.34375 11.75 9.13388 11.75 8.875V8.40625C11.75 8.14737 11.9552 7.9375 12.2083 7.9375C12.4615 7.9375 12.6667 7.72763 12.6667 7.46875C12.6667 7.20987 12.8719 7 13.125 7H15.875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91667 9.34375C9.91667 9.08487 10.1219 8.875 10.375 8.875H10.8333C11.0865 8.875 11.2917 8.66513 11.2917 8.40625C11.2917 8.14737 11.0865 7.9375 10.8333 7.9375H10.375C9.61561 7.9375 9 8.5671 9 9.34375V20.5938C9 21.3704 9.61561 22 10.375 22H18.625C19.3844 22 20 21.3704 20 20.5938V9.34375C20 8.5671 19.3844 7.9375 18.625 7.9375H18.1667C17.9135 7.9375 17.7083 8.14737 17.7083 8.40625C17.7083 8.66513 17.9135 8.875 18.1667 8.875H18.625C18.8781 8.875 19.0833 9.08487 19.0833 9.34375V20.5938C19.0833 20.8526 18.8781 21.0625 18.625 21.0625H10.375C10.1219 21.0625 9.91667 20.8526 9.91667 20.5938V9.34375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9583 13.0938C14.9583 12.8349 14.7531 12.625 14.5 12.625C14.2469 12.625 14.0417 12.8349 14.0417 13.0938V14.5H12.6667C12.4135 14.5 12.2083 14.7099 12.2083 14.9688C12.2083 15.2276 12.4135 15.4375 12.6667 15.4375H14.0417V16.8438C14.0417 17.1026 14.2469 17.3125 14.5 17.3125C14.7531 17.3125 14.9583 17.1026 14.9583 16.8438V15.4375H16.3333C16.5865 15.4375 16.7917 15.2276 16.7917 14.9688C16.7917 14.7099 16.5865 14.5 16.3333 14.5H14.9583V13.0938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramActionSvg);
export default __webpack_public_path__ + "static/media/program-action-svg.7cfcee9ff693d74cff9ed48e572dba15.svg";
export { ForwardRef as ReactComponent };